import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplaySelectMany from './DisplaySelectMany';
import EditSelectMany from './EditSelectMany';

const SelectManyInputContainer = ({
    iconName,
    initialValue: onPageLoadValues,
    options,
    syncChanges,
    isEditing,
    setIsEditing,
    isHovered,
}) => {
    const [values, setValues] = useState(onPageLoadValues && onPageLoadValues.length ? onPageLoadValues : []);
    const [initialValues, setInitialValues] = useState(onPageLoadValues && onPageLoadValues.length ? onPageLoadValues : []);
    const isFieldNull = !values.length;

    useEffect(() => {
        setValues(onPageLoadValues && onPageLoadValues.length ? onPageLoadValues : []);
        setInitialValues(onPageLoadValues && onPageLoadValues.length ? onPageLoadValues : []);
    }, [onPageLoadValues]);

    const valueHasntChanged = () => {
        if (values.length === 0 || initialValues.length === 0) {
            return values.length === initialValues.length;
        }
        return values.every((i) => initialValues.some((ii) => i.id === ii.id)) &&
            initialValues.every((i) => values.some((ii) => i.id === ii.id));
    };

    const handleSave = async () => {
        const response = await syncChanges(values);
        if (response.success) {
            setInitialValues([...values]);
            setValues([...values]);
        }
        return response;
    };

    const handleCancel = () => {
        setValues([...initialValues]);
        setIsEditing(false);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplaySelectMany {...{ values }} />
            <EditSelectMany {...{ iconName, value: values, setValue: setValues, options, handleCancel }} />
        </GenericInputContainer>
    );
};

export default SelectManyInputContainer;
